import { CheckCircleIcon } from '@heroicons/react/solid';
import { Spinner } from '@yoast/ui-library';
import cx from 'classnames';
import PropTypes from 'prop-types';

import GradientText from './GradientText';
import ProgressBarGradient from './ProgressBarGradient';

const PHASES = [
  { labelAbove: 'Running queries...', threshold: 80 },
  {
    labelAbove: 'Building analysis...',
    threshold: 90
  },
  { labelAbove: 'Finalizing...', threshold: 99 },
  { labelAbove: 'Done!', threshold: 100 },
];

const ProgressPhases = ({ progress = 0, className = '' }) => {
  // Determine current phase based on progress
  const getCurrentPhase = () => {
    for (let i = 0; i < PHASES.length; i++) {
      if (progress <= PHASES[i].threshold) {
        return PHASES[i];
      }
    }
    return PHASES[PHASES.length - 1];
  };

  const currentPhase = getCurrentPhase();

  // Determine if we're in the "Running queries" phase (0-80) or "Building analysis" phase (81+)
  const isRunningQueriesPhase = progress <= 80;

  return (
    <div className={cx('yst-font-medium yst-text-slate-800', className)}>
      <div className="yst-flex yst-items-center yst-justify-center yst-gap-2">
        {progress < 100 ? (
          <Spinner />
        ) : (
          <CheckCircleIcon className="yst-text-green-400" />
        )}
        <span className="yst-text-sm yst-font-medium yst-italic">
          {currentPhase.labelAbove}
        </span>
      </div>
      <ProgressBarGradient
        className="yst-mt-3"
        progress={progress}
        min={0}
        max={100}
      />
      <div className="yst-mt-3 yst-flex yst-justify-between yst-text-xs">
        <span>
          <GradientText disabled={!isRunningQueriesPhase}>
            Running queries
          </GradientText>
        </span>
        <span>
          <GradientText disabled={isRunningQueriesPhase}>
            Building analysis
          </GradientText>
        </span>
      </div>
    </div>
  );
};

ProgressPhases.propTypes = {
  progress: PropTypes.number,
  className: PropTypes.string,
};

export default ProgressPhases;
